import React from 'react';

const statusConfig = {
  ACTIVE: {
    emoji: '🟢',
    label: 'Kohal',
    color: '#22c55e',
    bgColor: '#ecfdf3'
  },
  IDLE: {
    // Treat IDLE same as LEFT now
    emoji: '🔴',
    label: 'Lahkunud',
    color: '#ef4444',
    bgColor: '#fef2f2'
  },
  LEFT: {
    emoji: '🔴',
    label: 'Lahkunud',
    color: '#ef4444',
    bgColor: '#fef2f2'
  }
};

function StudentTile({ student, showAnalytics = false, formatLastAttempt }) {
  const config = statusConfig[student.status] || statusConfig.LEFT;

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 4px 12px rgba(15, 23, 42, 0.08)',
      border: `2px solid ${config.color}`,
      transition: 'all 0.3s ease'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '12px'
      }}>
        <div style={{
          fontSize: '16px',
          fontWeight: '700',
          color: '#111827'
        }}>
          {student.displayName}
        </div>
        <div style={{ fontSize: '24px' }}>
          {config.emoji}
        </div>
      </div>

      {/* Status Badge */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        borderRadius: '8px',
        background: config.bgColor,
        marginBottom: showAnalytics ? '12px' : '0'
      }}>
        <div style={{
          fontSize: '12px',
          fontWeight: '600',
          color: config.color,
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          {config.label}
        </div>
        {student.status === 'ACTIVE' && student.lastSeenSec !== undefined && student.lastSeenSec < 60 && (
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            marginLeft: 'auto'
          }}>
            {student.lastSeenSec}s tagasi
          </div>
        )}
        {student.status !== 'ACTIVE' && (
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            marginLeft: 'auto'
          }}>
            lahkunud
          </div>
        )}
      </div>

      {/* Analytics Section */}
      {showAnalytics && (
        <div style={{
          borderTop: '1px solid #e5e7eb',
          paddingTop: '12px',
          marginTop: '4px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '8px',
            marginBottom: '8px'
          }}>
            <div style={{
              background: '#f9fafb',
              padding: '8px 12px',
              borderRadius: '8px'
            }}>
              <div style={{ fontSize: '10px', color: '#6b7280', marginBottom: '2px' }}>
                Katseid
              </div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#111827' }}>
                {student.totalAttempts || 0}
              </div>
            </div>
            <div style={{
              background: '#f9fafb',
              padding: '8px 12px',
              borderRadius: '8px'
            }}>
              <div style={{ fontSize: '10px', color: '#6b7280', marginBottom: '2px' }}>
                Õigeid
              </div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#22c55e' }}>
                {student.correctAttempts || 0}
              </div>
            </div>
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <div style={{ fontSize: '11px', color: '#6b7280' }}>
                Edukus:
              </div>
              <div style={{
                fontSize: '14px',
                fontWeight: '700',
                color: (student.passRate || 0) >= 70 ? '#22c55e' :
                  (student.passRate || 0) >= 40 ? '#f59e0b' : '#ef4444'
              }}>
                {student.passRate || 0}%
              </div>
            </div>
            {formatLastAttempt && (
              <div style={{
                fontSize: '11px',
                color: '#9ca3af'
              }}>
                {formatLastAttempt(student.lastAttempt)}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default StudentTile;
